import { Field, LinkField, Text, Link, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';

import { type contextType, DynamicButtonContext } from 'components/DynamicButtons/DynamicButtons';
import Button from 'components/helpers/Button/Button';

import styles from './DynamicButton.module.scss';
import { TokenReplace } from 'lib/utils';

const cx = classNames.bind(styles);

export type DynamicButtonProps = {
  choiceText: Field<string>;
  linkLocation: LinkField;
  nextSectionId: string | null;
};

const DynamicButton = (props: DynamicButtonProps): React.JSX.Element | null => {
  const { choiceText, linkLocation, nextSectionId } = props;
  const { setButtonClicked, setCurrentSection } = React.useContext(DynamicButtonContext) as contextType;
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    TokenReplace();
  });

  if (linkLocation?.value?.href !== '') {
    return (
      <li>
        <Link
          className={cx('dynamic-buttons__choice', 'dynamic-buttons__choice--link')}
          field={linkLocation}
          title={linkLocation.value.href}
          showLinkTextWithChildrenPresent={false}
        >
          <Text field={choiceText} encode={sitecoreContext.pageEditing} />
        </Link>
      </li>
    );
  }

  if (nextSectionId !== null) {
    return (
      <li>
        <Button
          aria-controls={nextSectionId}
          className={cx('dynamic-buttons__choice', 'dynamic-buttons__choice--button')}
          icon="carat"
          onClick={() => {
            setButtonClicked(true);
            setCurrentSection(nextSectionId);
          }}
          type="button"
        >
          <Text field={choiceText} encode={sitecoreContext.pageEditing} />
        </Button>
      </li>
    );
  }

  return null;
};

export default DynamicButton;
